// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyBYe3oOwh9E0yZt8mZE0Ft1OoVlr4tcJzE',
  authDomain: 'boardly-66b86.firebaseapp.com',
  projectId: 'boardly-66b86',
  storageBucket: 'boardly-66b86.firebasestorage.app',
  messagingSenderId: '344446957533',
  appId: '1:344446957533:web:a182e79b79970369fe2834',
  measurementId: 'G-VB5RL9LGPF',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

if (process.env.NODE_ENV !== 'production') {
  window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}

const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider('6LdaRMgsAAAAAKSe7L3gWW-kjgDUtM9vL56cYg3g'),
  isTokenAutoRefreshEnabled: true,
});

export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
